module.exports = __webpack_public_path__ + "img/skill-1.074b26f5.png";